import * as React from 'react';

export interface SelectedFilterOption {
  id: string;
  origin: string;
  searchKey: string;
  searchValue: string;
}

const SelectedFilterOptionsContext = React.createContext<
  | [
      SelectedFilterOption[],
      React.Dispatch<React.SetStateAction<SelectedFilterOption[]>>,
    ]
  | null
>(null);

function useSelectedFilterOptions() {
  const context = React.useContext(SelectedFilterOptionsContext);

  if (!context) {
    throw new Error(
      'useSelectedFilterOptions must be used within a SelectedFilterOptionsProvider',
    );
  }

  return context;
}

function SelectedFilterOptionsProvider({ defaultOptions = [], ...props }) {
  const [selectedFilterOptions, setSelectedFilterOptions] =
    React.useState<SelectedFilterOption[]>(defaultOptions);

  const value = React.useMemo(
    () => [selectedFilterOptions, setSelectedFilterOptions],
    [selectedFilterOptions],
  );

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  return <SelectedFilterOptionsContext.Provider value={value} {...props} />;
}

export { SelectedFilterOptionsProvider, useSelectedFilterOptions };
